import { useState } from 'react';
import { Popover, Avatar, Tabs, List, Button, Typography, App, Space } from 'antd';
import {
  LogoutOutlined,

} from '@ant-design/icons';
import avatar1 from 'assets/images/users/avatar-1.png';
import { useAuth } from 'contexts/AuthContext';

const { Text } = Typography;


export default function Profile() {
  const [open, setOpen] = useState(false);
  const { logout } = useAuth()
  const { modal } = App.useApp();

  const handleLogout = () => {
    modal.confirm({
      title: "Are you sure you want to logout?",
      okText: "Logout",
      cancelText: "Cancel",
      onOk: () => {
        logout();
      },
    });
  };
  const content = (
    <div style={{ width: 280 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Avatar src={avatar1} size={40} />
          <div>
            <Text strong style={{ display: 'block', fontSize: 13 }}>Admin</Text>
            <Text type="secondary" style={{ fontSize: 12 }}>42kicks Admin</Text>
          </div>
        </div>
        <Button type="text" danger onClick={handleLogout} icon={<LogoutOutlined />} />
      </div>
      {/* <Tabs
        size="small"
        items={[
          { key: 'profile', label: <><UserOutlined /> Profile</>, children: <ProfileTab /> },
          { key: 'setting', label: <><SettingOutlined /> Setting</>, children: <SettingTab /> }
        ]}
      /> */}
    </div>
  );

  return (
    <Popover content={content} trigger="click" open={open} onOpenChange={setOpen} placement="bottomRight">
      <Space>
        <span style={{ fontSize: 13, fontWeight: 600 }}>👋 Welcome, Admin</span>
        <Avatar src={avatar1} size={36} style={{ cursor: 'pointer' }} />
      </Space>
    </Popover>
  );
}
